var {AmpersandState, AmpersandCollection} = require('catalog/libs');

/**
 * filter model
 * model hierarchy: filterlist > facet > filtergroup > filter (this)
 */
var FilterModel = AmpersandState.extend({

    props: {
        context: 'string',
        type: 'string',
        parentId: 'string',
        facetValue: 'string',
        facetValueId: 'string',
        facetCount: 'string',
        isChecked: ['boolean', false, false]
    },

    derived: {
        groupname: {
            deps: ['parentId'],
            fn: function() {
                return this.parentId + '[]';
            }
        },
        domid: {
            deps: ['facetValueId', 'parentId'],
            fn: function() {
                return this.parentId + '_' + this.facetValueId.replace(/\+/g, '_');
            }
        },
        formatCount: {
            deps: ['facetCount'],
            fn: function() {
                return '(' + this.facetCount + ')';
            }
        },
        analyticsEvent: {
            deps: ['context'],
            fn: function() {
                return this.context + ' filter-track-click';
            }
        }
    }
});

/**
 * collection of filter models
 */
var FilterCollection = AmpersandCollection.extend({
    model: FilterModel
});

module.exports = FilterCollection;
